import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { JsonService } from '../../services/core/json.service';
import { catchError, tap } from 'rxjs/operators';
import { HrApiResources } from './hr.constants';

@Injectable({
  providedIn: 'root',
})
export class HrDataService {
  private baseURL;
  private _staffID = '';
  constructor(private http: HttpClient, private jsonService: JsonService) {
    this.baseURL = HrApiResources;
  }

  list(model: any): Observable<any> {
    const endPoint = `${this.baseURL.staffListingWithSearch}`;
    return this.http.post<any>(endPoint, model).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  // getting staff-listing
  getStaffListing(model: any = []): Observable<any> {
    const endPoint = `${this.baseURL.getStaffListing}`;
    return this.http
      .get<any>(endPoint, {
        params: model,
      })
      .pipe(
        tap((data) => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
  }

  // get roles
  getRoles(): Observable<any> {
    const endPoint = `${this.baseURL.getRoles}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  // get Active Departments
  getActiveDepartments(): Observable<any> {
    const endPoint = `${this.baseURL.getActiveDepartments}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get Staff certificates
  getStaffCertificates(params: any = {}): Observable<any> {
    const endPoint = `${this.baseURL.getStaffCertificates}`;
    let httpParams = new HttpParams();
    for (const key in params) {
      if (
        params.hasOwnProperty(key) &&
        params[key] !== null &&
        params[key] !== undefined &&
        params[key] !== ''
      ) {
        httpParams = httpParams.append(key, params[key]);
      }
    }

    return this.http.get<any>(endPoint, { params: httpParams }).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  // create staff
  createStaff(data: any): Observable<any> {
    const endPoint = `${this.baseURL.createStaff}`;
    return this.http.post<any>(endPoint, data).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  createProfileImage(id: any, data: any): Observable<any> {
    const endPoint = `${this.baseURL.createProfileImage}/${id}`;
    return this.http.post<any>(endPoint, data).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  // get language+timezone list
  getLanguageTimeZone(): Observable<any> {
    const endPoint = `${this.baseURL.getLanguageTimezone}?per_page=9999`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  // get saved localization defaults (used to auto-select default Time Zone on staff create)
  getLocalization(): Observable<any> {
    const endPoint = `${this.baseURL.getLocalization}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get Single Staff
  // getSingleStaff(id: any): Observable<any> {
  //   const endPoint = `${this.baseURL.getSingleStaffData}/${id}`;
  //   return this.http.get<any>(endPoint).pipe(
  //     tap((data) => this.jsonService.doStringify(data)),
  //     catchError(this.errorHandlerMessage)
  //   );
  // }

  //get Single Staff

  getSingleStaff(id: any, params?: any): Observable<any> {
    const endPoint = `${this.baseURL.getSingleStaffData}/${id}`;
    return this.http.get<any>(endPoint, { params }).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  // Terminate staff
  terminateStaff(data: any, id: any): Observable<any> {
    const endPoint = `${this.baseURL.terminateStaff}/${id}`;
    return this.http.patch<any>(endPoint, data).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //deleteStaff Data
  deleteStaffData(id: any): Observable<any> {
    const endPoint = `${this.baseURL.deleteStaffData}/${id}`;
    return this.http.delete<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //update Staff Data
  updateStaffData(id: any, data: any): Observable<any> {
    const endPoint = `${this.baseURL.updateStaffData}/${id}?first_name=${data?.first_name}
    &last_name=${data?.last_name}&email=${data?.email}&password=${data?.password}&phone_number=${data?.phone_number}
    &department=${data?.department?.id}&start_date=${data?.start_date}&birthday=${data?.birthday}&language=${data?.language}
    &time_zone=${data?.time_zone}&address_line_1=${data?.address_line_1}&address_line_2=${data?.address_line_2}&&state_id=${data?.state_id?.id}
    &city=${data?.city}&zipcode=${data?.zipcode}&salary=${data?.salary}&status=${data?.status}&certificates[0][certificate_id]=${data?.certificates?.id}
    &certificates[0][file]=${data.certificates?.file_id}&certificates[0][expire_at]=${data?.certificates?.expiration_date}&role=${data?.role}`;
    return this.http.patch<any>(endPoint, data).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  // get Staff Statuses
  getStaffStatuses(requestparam: any = {}): Observable<any> {
    const endPoint = `${this.baseURL.getStaffStatuses}`;
    let params = new HttpParams();
    for (const key in requestparam) {
      if (requestparam.hasOwnProperty(key)) {
        params = params.append(key, requestparam[key]);
      }
    }

    return this.http.get<any>(endPoint, { params }).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  // change staff Status
  changeStaffStatus(id: any, data: any): Observable<any> {
    const endPoint = `${this.baseURL.changeStaffStatus}/${id}`;
    return this.http.patch<any>(endPoint, data).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  onHoldStaff(id: any, data: any): Observable<any> {
    const endPoint = `${this.baseURL.onHoldStaff}/${id}`;
    return this.http.patch<any>(endPoint, data).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //Change Staff Password
  changeStaffPassword(id: number, data: any) {
    const endPoint = `${this.baseURL.changeStaffPasswordBase}/${id}/change/password`;
    return this.http.post<any>(endPoint, data);
  }

  //getStaffId
  saveStaffId(id: any) {
    return (this._staffID = id);
  }

  //getStaffId
  getStaffId() {
    return this._staffID;
  }

  //getStaffDocuments
  getStaffDocument(id: any): Observable<any> {
    const endPoint = `${this.baseURL.getStaffDocument}/${id}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //create Work Schedule
  createWorkSchedule(data: any): Observable<any> {
    const endPoint = `${this.baseURL.createWorkSchedule}`;
    return this.http.post<any>(endPoint, data).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get Work Schedule
  getWorkSchedule(staffId: any): Observable<any> {
    const endPoint = `${this.baseURL.getWorkSchedule}/${staffId}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //clock in
  clockIn(staffId: any): Observable<any> {
    const endPoint = `${this.baseURL.clockIn}/${staffId}`;
    return this.http.post<any>(endPoint, {}).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //clock out
  clockOut(staffId: any): Observable<any> {
    const endPoint = `${this.baseURL.clockOut}/${staffId}`;
    return this.http.post<any>(endPoint, {}).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get clock status
  getStaffClockStatus(staffId: any): Observable<any> {
    const endPoint = `${this.baseURL.getClockStatus}/${staffId}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get weekly timesheet
  getWeeklyTimesheet(staffId: any): Observable<any> {
    const endPoint = `${this.baseURL.getWeeklyTimesheet}/${staffId}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get recent time entries
  getRecentTimeEntries(staffId: any, params: any): Observable<any> {
    const endPoint = `${this.baseURL.getRecentTimeEntries}/${staffId}`;
    return this.http.get<any>(endPoint, { params }).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //delete time entry
  deleteTimeEntry(entryId: any): Observable<any> {
    const endPoint = `${this.baseURL.deleteTimeEntry}/${entryId}`;
    return this.http.delete<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //update time entry
  updateTimeEntry(entryId: any, clockIn: string, clockOut: string): Observable<any> {
    const endPoint = `${this.baseURL.updateTimeEntry}/${entryId}/edit?clock_in=${clockIn}&clock_out=${clockOut}`;
    return this.http.patch<any>(endPoint, {}).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get attendance overview
  getAttendanceOverview(staffId: any): Observable<any> {
    const endPoint = `${this.baseURL.getAttendanceOverview}/${staffId}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //create time off request (PTO)
  createTimeOffRequest(data: any): Observable<any> {
    const endPoint = `${this.baseURL.createTimeOffRequest}`;
    return this.http.post<any>(endPoint, data).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get PTO approval queue
  getPTOApprovalQueue(params: any = {}): Observable<any> {
    const endPoint = `${this.baseURL.getPTOApprovalQueue}`;
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && params[key] !== '') {
        httpParams = httpParams.append(key, params[key]);
      }
    }
    return this.http.get<any>(endPoint, { params: httpParams }).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //bulk update time off request status
  bulkUpdateTimeOffStatus(data: any): Observable<any> {
    const endPoint = `${this.baseURL.bulkUpdateTimeOffStatus}`;
    return this.http.post<any>(endPoint, data).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get PTO pending count
  getPTOPendingCount(): Observable<any> {
    const endPoint = `${this.baseURL.getPTOPendingCount}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get PTO balance with requests
  getPTOBalance(staffId: any, recentPage: number = 1, pastPage: number = 1): Observable<any> {
    const endPoint = `${this.baseURL.getPTOBalance}/${staffId}?recent_page=${recentPage}&past_page=${pastPage}&per_page=10`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //update PTO request status (approve/deny)
  updatePTORequestStatus(requestId: any, status: string): Observable<any> {
    const endPoint = `${this.baseURL.updatePTORequestStatus}/${requestId}/status?status=${status}`;
    return this.http.patch<any>(endPoint, {}).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  // Upload a file via the existing generic attachments endpoint (module_id 11 = Staff,
  // same one Product's "Add Picture" uses). Returns { attachment_id, attach_file }.
  // The attachment_id is staged on the frontend and sent as part of file_ids when the
  // time off request is submitted (see createTimeOffRequest) — not linked here.
  uploadAttachment(file: File, attachmentField: string = 'time_off_document'): Observable<any> {
    const endPoint = `${this.baseURL.uploadAttachment}`;
    const formData = new FormData();
    formData.append('attachment', file);
    formData.append('module_id', '11');
    formData.append('attachment_field', attachmentField);
    return this.http.post<any>(endPoint, formData).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  // Same upload, but reporting real progress events so the dialog can show a
  // progress bar (like Product's "Add Picture") instead of just a spinner.
  uploadAttachmentWithProgress(file: File, attachmentField: string = 'time_off_document'): Observable<HttpEvent<any>> {
    const endPoint = `${this.baseURL.uploadAttachment}`;
    const formData = new FormData();
    formData.append('attachment', file);
    formData.append('module_id', '11');
    formData.append('attachment_field', attachmentField);
    const req = new HttpRequest('POST', endPoint, formData, { reportProgress: true });
    return this.http.request(req).pipe(catchError(this.errorHandlerMessage));
  }

  // Delete an attachment outright (used when a file is removed from the dialog
  // before the request is submitted, so it doesn't stay orphaned in attach_files).
  deleteAttachment(attachmentId: any): Observable<any> {
    const endPoint = `${this.baseURL.uploadAttachment}/${attachmentId}`;
    return this.http.delete<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  // Documents already linked to a submitted time off request (pivot -> attach_files)
  getTimeOffRequestDocuments(timeOffRequestId: any): Observable<any> {
    const endPoint = `${this.baseURL.timeOffRequestDocuments}/${timeOffRequestId}/documents`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  deleteTimeOffRequestDocument(timeOffRequestId: any, documentId: any): Observable<any> {
    const endPoint = `${this.baseURL.timeOffRequestDocuments}/${timeOffRequestId}/documents/${documentId}`;
    return this.http.delete<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get license certificate categories
  getLicenseCertificateCategories(): Observable<any> {
    const endPoint = `${this.baseURL.getLicenseCertificateCategories}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //create staff license/certificate
  createStaffLicenseCertificate(data: any): Observable<any> {
    const endPoint = `${this.baseURL.createStaffLicenseCertificate}`;
    return this.http.post<any>(endPoint, data).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //update staff license/certificate
  updateStaffLicenseCertificate(certificateId: any, params: any = {}): Observable<any> {
    const endPoint = `${this.baseURL.updateStaffLicenseCertificate}/${certificateId}`;
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && params[key] !== '') {
        httpParams = httpParams.append(key, params[key]);
      }
    }
    return this.http.patch<any>(endPoint, {}, { params: httpParams }).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get all staff certificates
  getAllStaffCertificates(staffId: any, params: any = {}): Observable<any> {
    const endPoint = `${this.baseURL.getAllStaffCertificates}/${staffId}`;
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && params[key] !== '') {
        httpParams = httpParams.append(key, params[key]);
      }
    }
    return this.http.get<any>(endPoint, { params: httpParams }).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //delete staff license/certificate
  deleteStaffLicenseCertificate(certificateId: any): Observable<any> {
    const endPoint = `${this.baseURL.deleteStaffLicenseCertificate}/${certificateId}`;
    return this.http.delete<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get staff skill categories
  getStaffCategories(): Observable<any> {
    const endPoint = `${this.baseURL.getStaffCategories}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get skill names by category
  getSkillNamesByCategory(categoryId: number): Observable<any> {
    const endPoint = `${this.baseURL.getSkillNamesByCategory}/${categoryId}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //create staff skill qualification
  createStaffSkillQualification(data: any): Observable<any> {
    const endPoint = `${this.baseURL.createStaffSkillQualification}`;
    return this.http.post<any>(endPoint, data).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //update staff skill qualification
  updateStaffSkillQualification(skillId: number, data: any): Observable<any> {
    const endPoint = `${this.baseURL.updateStaffSkillQualification}/${skillId}`;
    // Build query parameters
    let params = new HttpParams();
    if (data.staff_Category_id)
      params = params.append('staff_Category_id', data.staff_Category_id);
    if (data.staff_skill_name_id)
      params = params.append('staff_skill_name_id', data.staff_skill_name_id);
    if (data.staff_id) params = params.append('staff_id', data.staff_id);
    if (data.Proficiency_Level) {
      params = params.append('Proficiency_Level', data.Proficiency_Level);
    }
    if (
      data.Years_of_Experience !== null &&
      data.Years_of_Experience !== undefined
    ) {
      params = params.append(
        'Years_of_Experience',
        data.Years_of_Experience.toString()
      );
    }
    if (data.is_certified !== null && data.is_certified !== undefined) {
      params = params.append('is_certified', data.is_certified.toString());
    }

    return this.http.patch<any>(endPoint, {}, { params }).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //delete staff skill qualification
  deleteStaffSkillQualification(skillId: number): Observable<any> {
    const endPoint = `${this.baseURL.updateStaffSkillQualification}/${skillId}`;
    return this.http.delete<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get staff skills qualifications
  getStaffSkillsQualifications(staffId: number): Observable<any> {
    const endPoint = `${this.baseURL.getStaffSkillsQualifications}/${staffId}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //create staff contact (emergency contact)
  createStaffContact(data: any): Observable<any> {
    const endPoint = `${this.baseURL.createStaffContact}`;
    // Build payload - only include email if provided
    const payload: any = {
      staff_id: data.staff_id,
      Contact_Name: data.Contact_Name,
      RelationShip: data.RelationShip,
      Primary_contact: data.Primary_contact,
      secondary_contact: data.secondary_contact || null,
      is_emergency: data.is_emergency || 0,
    };
    // Add email only if provided
    if (data.email) {
      payload.email = data.email;
    }
    return this.http.post<any>(endPoint, payload).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get staff contact (emergency contact)
  getStaffContact(staffId: number): Observable<any> {
    const endPoint = `${this.baseURL.getStaffContact}/${staffId}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //update staff contact (emergency contact)
  updateStaffContact(contactId: number, data: any): Observable<any> {
    const endPoint = `${this.baseURL.updateStaffContact}/${contactId}`;

    // Build query parameters as per API requirement
    let params = new HttpParams();
    if (data.staff_id) params = params.append('staff_id', data.staff_id);
    if (data.Contact_Name)
      params = params.append('Contact_Name', data.Contact_Name);
    if (data.RelationShip)
      params = params.append('RelationShip', data.RelationShip);
    if (data.Primary_contact)
      params = params.append('Primary_contact', data.Primary_contact);
    if (data.secondary_contact)
      params = params.append('secondary_contact', data.secondary_contact);
    // Add email as query parameter if provided
    if (data.email) {
      params = params.append('email', data.email);
    }
    if (data.is_emergency !== null && data.is_emergency !== undefined) {
      params = params.append('is_emergency', data.is_emergency.toString());
    }

    return this.http.patch<any>(endPoint, {}, { params }).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //delete staff contact (emergency contact)
  deleteStaffContact(contactId: number): Observable<any> {
    const endPoint = `${this.baseURL.deleteStaffContact}/${contactId}`;
    return this.http.delete<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get staff training types
  getStaffTrainingTypes(): Observable<any> {
    const endPoint = `${this.baseURL.getStaffTrainingTypes}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //create staff training
  createStaffTraining(data: any): Observable<any> {
    const endPoint = `${this.baseURL.createStaffTraining}`;
    return this.http.post<any>(endPoint, data).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //get staff trainings
  getStaffTrainings(staffId: number): Observable<any> {
    const endPoint = `${this.baseURL.getStaffTrainings}/${staffId}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //update staff training
  updateStaffTraining(trainingId: number, data: any): Observable<any> {
    const endPoint = `${this.baseURL.updateStaffTraining}/${trainingId}`;
    // Build query parameters
    let params = new HttpParams();
    if (data.staff_id) params = params.append('staff_id', data.staff_id);
    if (data.training_type_id)
      params = params.append('training_type_id', data.training_type_id);
    if (data.training_name)
      params = params.append('training_name', data.training_name);
    if (data.completion_date)
      params = params.append('completion_date', data.completion_date);
    if (data.training_provider)
      params = params.append('training_provider', data.training_provider);
    if (data.file_id !== null && data.file_id !== undefined)
      params = params.append('file_id', data.file_id);
    if (data.expiry_date) params = params.append('expiry_date', data.expiry_date);
    if (data.certificate_card_number)
      params = params.append('certificate_card_number', data.certificate_card_number);

    return this.http.patch<any>(endPoint, {}, { params }).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  //delete staff training
  deleteStaffTraining(trainingId: number): Observable<any> {
    const endPoint = `${this.baseURL.deleteStaffTraining}/${trainingId}`;
    return this.http.delete<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  /**
   * Update staff rating
   * POST /api/v1/user/{staffId}/update-rating
   * @param staffId - Staff ID
   * @param rating - Rating value (1-5)
   */
  updateStaffRating(staffId: number, rating: number): Observable<any> {
    const endPoint = `${this.baseURL.updateStaffRating}/${staffId}/update-rating`;
    const payload = { rating };
    return this.http.post<any>(endPoint, payload).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  /**
   * Get staff rating
   * GET /api/v1/user/{staffId}/rating
   * @param staffId - Staff ID
   */
  getStaffRating(staffId: number): Observable<any> {
    const endPoint = `${this.baseURL.getStaffRating}/${staffId}/rating`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  /**
   * Get current user count and max_users limit for the tenant.
   */
  getUserLimit(): Observable<any> {
    const endPoint = `${this.baseURL.getUserLimit}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  /**
   * Get concurrent user count and limit for the tenant.
   */
  getConcurrentUserLimit(): Observable<any> {
    const endPoint = `${this.baseURL.getConcurrentUserLimit}`;
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  // Bulk delete: DELETE hr/delete/multiple with { staff_ids: [...] }
  deleteMultiple(staffIds: any[]): Observable<any> {
    const endPoint = `${this.baseURL.deleteMultiple}`;
    return this.http.request<any>('delete', endPoint, { body: { staff_ids: staffIds } }).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  // Pre-check which of the selected staff can be deleted (and why not, for the rest)
  deleteAvailability(staffIds: any[]): Observable<any> {
    const endPoint = `${this.baseURL.deleteAvailability}`;
    return this.http.post<any>(endPoint, { staff_ids: staffIds }).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  errorHandler(error: HttpErrorResponse) {
    return observableThrowError(error.error || 'Server Error');
  }

  errorHandlerMessage(error: HttpErrorResponse) {
    return observableThrowError(error.error || 'Server Error');
  }
}
